import { isVideoStation } from '@app/core/stations/helpers';
import { Station } from '@mi-front/core';

export function useIsCfrTranscodingEnabled(station: Station) {
  return isVideoStation(station) && station.featuresConfig?.fragments?.cfrTranscoding?.enabled;
}
